import ViewListIcon from '@material-ui/icons/ViewList';
import UserManual from './List/List';
import { UserManualCreate } from './Create/Create';

export const userManualResource = {
	list: UserManual,
	icon: ViewListIcon,
    create: UserManualCreate,
}
